/** Map GET /api/v1/player/me response to legacy userData shape used across the UI. */
export function normalizePlayer(player = {}) {
  return {
    id: player.id,
    username: player.username || "",
    email: player.email || "",
    phone: player.phone || "",
    phoneVerified: player.phone_verified ?? player.phoneVerified ?? false,
    firstName: player.first_name || player.firstName || "",
    lastName: player.last_name || player.lastName || "",
    dob: player.dob || player.date_of_birth || player.dateOfBirth || "",
    country: player.country || "",
    state: player.state || "",
    city: player.city || "",
    address: player.address || "",
    pincode: player.pincode || "",
    status: player.status || "",
    kycVerified: player.kyc_verified ?? player.kycVerified ?? false,
    currency: player.currency || "INR",
    vipLevel: player.vip_level || player.vipLevel || "",
    allowDeposits: player.allow_deposits ?? player.allowDeposits ?? true,
    allowWithdrawals:
      player.allow_withdrawals ?? player.allowWithdrawals ?? true,
    totalBalance: player.total_balance ?? player.totalBalance ?? 0,
    redisBalance:
      player.withdrawal_balance ??
      player.withdrawalBalance ??
      player.redisBalance ??
      player.total_balance ??
      player.totalBalance ??
      0,
    bonus: player.bonus_balance ?? player.bonusBalance ?? player.bonus ?? 0,
  };
}
